export default "__VITE_ASSET__BKYalkX4__"